const ContingencyFundCalculator = {
  init: () => {
    const input = document.getElementById('contingencyFundWageAmount');
    const result = document.getElementsByClassName('js-contingency-result')[0];

    if (!input) {
      return;
    }
    
    input.addEventListener('input', (e) => {
        const value = Number(e.target.value);
        const proportions = Number(result.dataset.proportions);
        if (value) {
          /** @type {HTMLSpanElement} */
          const resultSpan = result.getElementsByClassName('js-contingency-money')[0];
          const resultText = result.getElementsByTagName('p')[0];
          if (resultSpan) {
            const format = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

            const rounded = Math.round(value * proportions);

            resultText.textContent = result.dataset.template.replace('{wage}',  format(value));
            resultSpan.textContent = `${format(rounded)} ISK`;
            result.style = null;
          }
        }
        else {
          result.style = 'display:none;';
        }
      });
  },
};

export default ContingencyFundCalculator;
